<div class="p-p-2">
    <span class="p-float-label">
        <p-inputNumber [(ngModel)]="value" mode="currency" currency="USD" locale="en-US" (onTouched)="onTouched()"
            (ngModelChange)="onChange()" [size]="size" [disabled]="disabled" [minFractionDigits]="2"></p-inputNumber>
        <label for="field-id">{{label|translate}}</label>
    </span>
</div>